import { type TypographyProps } from "@chakra-ui/styled-system";
import { injectTypographyVariant } from "@/components/essentials/typography/variant";
import { safeGet } from "@/modules/utils/safe-get";
import { type InputProps } from "./Input";
import { type InputSize, type InputBreakPointSize } from "./type";

interface InputSizeValue {
  readonly h: InputProps["h"];
  readonly fontSize: TypographyProps["fontSize"];
  readonly fontWeight: TypographyProps["fontWeight"];
}

const inputSize = {
  base: {
    h: "2rem",
    ...injectTypographyVariant("text4"),
  },
  sm: {
    h: "2.5rem",
    ...injectTypographyVariant("text3"),
  },
  md: {
    h: "2.75rem",
    ...injectTypographyVariant("text2"),
  },
  lg: {
    h: "3rem",
    ...injectTypographyVariant("text1"),
  },
};

const switchInputSizeVariant = (size: InputSize): InputSizeValue => {
  return safeGet(inputSize, size);
};

export const injectInputSize = (size: InputSize | InputBreakPointSize): InputSizeValue => {
  if (typeof size === "string") {
    const { h, fontSize, fontWeight } = switchInputSizeVariant(size);
    return {
      h,
      fontSize,
      fontWeight,
    };
  } else {
    const { h: baseH, fontSize: baseFontSize, fontWeight: baseFontWeight } = switchInputSizeVariant(size.base);
    const { h: smH, fontSize: smFontSize, fontWeight: smFontWeight } = switchInputSizeVariant(size.sm);
    const { h: mdH, fontSize: mdFontSize, fontWeight: mdFontWeight } = switchInputSizeVariant(size.md);
    const { h: lgH, fontSize: lgFontSize, fontWeight: lgFontWeight } = switchInputSizeVariant(size.lg);
    return {
      h: {
        base: baseH as string,
        sm: smH as string,
        md: mdH as string,
        lg: lgH as string,
      },
      fontSize: {
        base: baseFontSize as string,
        sm: smFontSize as string,
        md: mdFontSize as string,
        lg: lgFontSize as string,
      },
      fontWeight: {
        base: baseFontWeight as string,
        sm: smFontWeight as string,
        md: mdFontWeight as string,
        lg: lgFontWeight as string,
      },
    };
  }
};
